import React from 'react';
import { Link } from 'react-router-dom';
import { Info, ArrowBack } from '@mui/icons-material';

const About = () => {
    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-amber-50/30">
            <div className="max-w-3xl mx-auto px-6 py-12">
                <Link
                    to="/"
                    className="inline-flex items-center space-x-2 text-amber-600 hover:text-amber-700 font-medium mb-8"
                >
                    <ArrowBack className="text-lg" />
                    <span>Retour à l'accueil</span>
                </Link>
                <div className="flex items-center space-x-4 mb-8">
                    <div className="w-14 h-14 bg-gradient-to-br from-amber-500 to-orange-500 rounded-2xl flex items-center justify-center shadow-lg">
                        <Info className="text-white text-2xl" />
                    </div>
                    <div>
                        <h1 className="text-3xl font-bold text-slate-900">À propos</h1>
                        <p className="text-slate-600">Netikash Flow – Solution de caisse et paiement</p>
                    </div>
                </div>
                <div className="prose prose-slate max-w-none space-y-6 text-slate-700">
                    <p className="text-lg leading-relaxed">
                        <strong>Netikash Flow</strong> est une suite professionnelle de gestion de point de vente (POS),
                        de facturation et de paiement, conçue pour les entreprises qui souhaitent simplifier leurs
                        encaissements et suivre leur activité en temps réel.
                    </p>
                    <p>
                        La plateforme permet de gérer les caisses, les caissiers, les clients, les articles,
                        les factures, les liens de paiement et les demandes de paiement, le tout centralisé
                        dans une interface moderne et sécurisée.
                    </p>
                    <p>
                        Développée par <strong>Netikash</strong>, cette solution s'intègre avec l'écosystème
                        de paiement mobile et les normes en vigueur pour offrir une expérience fiable aux
                        commerçants et à leurs clients.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default About;
